import * as React from 'react'

export interface InputProps extends React.ComponentProps<'input'> {
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', type, error = false, ...props }, ref) => {
    const baseClasses = 'flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors'
    const errorClasses = error ? 'border-destructive focus-visible:ring-destructive' : 'border-input'
    const classes = `${baseClasses} ${errorClasses} ${className}`.trim()
    
    return (
      <input
        type={type}
        className={classes}
        ref={ref}
        aria-invalid={error}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
export default Input
